import { createAction, props } from '@ngrx/store';
import { ListSearch } from '@ca/core/models';

const prefix = '[MyModules Page]';

export const loadMyModules = createAction(`${prefix} Load MyModules`, props<{ query?: ListSearch | undefined; isReloadEnforced?: boolean }>());
export const loadMyModulesTotalCount = createAction(`${prefix} Load MyModules Total Count`);
